<div
  class="warning flex flex-row gap-3"
  data-test-id="interview-period-call-overlap-warning"
>
  <mat-icon class="warning-icon">warning_amber</mat-icon>
  <div class="flex flex-col gap-2">
    <strong data-test-id="interview-period-call-overlap-warning-title">
      This time clashes with
      {{ overlaps().length === 1 ? 'another call' : 'other calls' }}
    </strong>
    <p>Please confirm this is suitable before proceeding.</p>
    <ul class="overlaps">
      @for (overlap of overlaps(); track $index) {
        <li data-test-id="interview-period-call-overlap-warning-call">
          {{ overlap.name }} · {{ overlap.time }}
        </li>
      }
    </ul>
    <span
      class="timezone"
      data-test-id="interview-period-call-overlap-warning-timezone"
    >
      Times shown in {{ timezoneName() }}
    </span>
  </div>
</div>
